import { disableGestures, enableGestures } from '@containerApp/deviceFunctions/gestures'
import { canCheckForContainerApp, isContainerApp } from '@util/device'
import { useEffect } from 'react'

const onBeforeUnload = () => void enableGestures()

export function useSetNavigationGestures(hasMainNavTab?: boolean): void {
    const canUseGestures = canCheckForContainerApp() && isContainerApp()

    useEffect(() => {
        // Make sure gestures are re-enabled before leaving the SPA, e.g. when navigating to a classic site page
        window.addEventListener('beforeunload', onBeforeUnload)

        return () => window.removeEventListener('beforeunload', onBeforeUnload)
    }, [canUseGestures, hasMainNavTab])

    // on route change start we are guaranteed that the gestures will be enabled
    // when the hook eventually runs with the new route make sure we update gestures
    useEffect(() => {
        if (!canUseGestures) {
            return
        }

        if (hasMainNavTab) {
            void disableGestures()
            return
        }

        void enableGestures()
    }, [canUseGestures, hasMainNavTab])
}
